import Vue from "vue";

const state = {
  account: null,
  accountInfo: null,
  accountUsers: null,
  detailedUsersList: null,
  inactiveUsers: null,
  accountPhoneForValidation: null,
  authId: null,
  authToken: null,
  adminAccount: null
};
const getters = {
  isAuthenticated: state => !!state.account,
  isAdmin: state => state.account.has_admin,
  getAccount: (state) => state.account,
  getAccountInfo: (state) => state.accountInfo,
  getAccountUsers: (state) => state.accountUsers,
  getDetailedUsersList: state => state.detailedUsersList,
  getInactiveUsers: state => state.inactiveUsers,
  getAdminAccount: (state) => state.adminAccount,
};

const actions = {
  setAccount({ commit }, account) {
    commit("SET_ACCOUNT", account);
  },
  setAdminAccount({ commit }, account) {
    commit("SET_ADMIN_ACCOUNT", account);
  },
  setAuthId({ commit }, authId) {
    commit("SET_AUTH_ID", authId);
  },
  setAuthToken({ commit }, token) {
    commit("SET_AUTH_TOKEN", token);
  },
  setAccountInfo({ commit }, account) {
    commit("SET_ACCOUNT_INFO", account);
  },
  setAccountUsers({ commit }, users) {
    commit("SET_ACCOUNT_USERS", users);
  },
  setDetailedUsersList({ commit }, usersList) {
    commit("SET_DETAILED_USERS_LIST", usersList);
  },
  setInactiveUsers({ commit }, usersList) {
    commit("SET_INACTIVE_USERS", usersList);
  },
  setAccountPhoneForValidation({ commit }, phoneNumber) {
    commit("SET_ACCOUNT_PHONE_FOR_VALIDATION", phoneNumber);
  },
  logoutAccount({ commit }) {
    commit("SET_ACCOUNT", null);
    commit("SET_ACCOUNT_INFO", null);
    commit("SET_ACCOUNT_USERS", null);
    commit("SET_DETAILED_USERS_LIST", null);
  },
};

const mutations = {
  SET_ACCOUNT(state, account) {
    Vue.set(state, "account", account);    
  },
  SET_ADMIN_ACCOUNT(state, account) {
    Vue.set(state, "adminAccount", account);    
  },
  SET_AUTH_ID(state, authId) {
    Vue.set(state, "authId", authId);
  },
  SET_AUTH_TOKEN(state, token) {
    Vue.set(state, "authToken", token);
  },
  SET_ACCOUNT_INFO(state, accountInfo) {
    Vue.set(state, "accountInfo", accountInfo);
  },
  SET_ACCOUNT_USERS(state, users) {
    Vue.set(state, "accountUsers", users);
  },
  SET_INACTIVE_USERS(state, usersList) {
    Vue.set(state, "inactiveUsers", usersList);
  },
  SET_ACCOUNT_PHONE_FOR_VALIDATION(state, phoneNumber) {
    Vue.set(state, "accountPhoneForValidation", phoneNumber);
  },
  SET_DETAILED_USERS_LIST(state, usersList) {
    Vue.set(state, "detailedUsersList", usersList);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
